import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { CraEsnService } from './../../../../../core/services/cra-esn/cra-esn.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-detail-workflowgen',
  templateUrl: './detail-workflowgen.component.html',
  styleUrls: ['./detail-workflowgen.component.css'],
})
export class DetailWorkflowgenComponent {
  company_id: any;
  id = this.activatedRoute.snapshot.params['id'];
  namesub: any;
  name = [
    { id: 1, name: 'Consultant' },
    { id: 2, name: 'Responsable' },
    { id: 3, name: 'RH' },
  ];
  state = [
    { id: 1, name: 'Validé' },
    { id: 2, name: 'Rejeté' },
  ];
  selectedworkflow: any;
  workflow: any;
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private activatedRoute: ActivatedRoute,
    private serviceCraEsn: CraEsnService,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) {}
  ngOnInit() {
    this.company_id = this.localStorageService.getData('clientConnected');
    this.getId();
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.id = params.params['id'];
        this.getWorkflowById();
      },
    });
  }

  getWorkflowById() {
    this.spinner.show();
    this.serviceCraEsn.getWorkflowdetail(this.id).pipe(takeUntil(this.unsubscribeAll)).subscribe({
      next: (res) => {
        this.selectedworkflow = res.data;
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  getSubWorkflowName(subWorkFlowItem: any): string {
    switch (subWorkFlowItem.name) {
      case '1':
        return 'Consultant';
      case '2':
        return 'Responsable';
      case '3':
        return 'RH';
      default:
        return '';
    }
  }
  getSubWorkflowState(subWorkFlowItem: any): string {
    switch (subWorkFlowItem.state) {
      case '1':
        return 'Validé';
      case '2':
        return 'Rejeté';

      default:
        return '';
    }
  }

  extractBeforeCompany(input: string): string {
    return input.replace(/_company\d*$/, '');
  }

  redirectListWorkflow(){
    this.router.navigateByUrl('/cra/list-workflow');
  }
  
}
